import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconPortalterrenocom from '../build/icon-portalterrenocom'

export const IconPortalterrenocom: React.FC<Omit<SvgProps, 'src'>> = (
  props
) => {
  return <Svg {...props} src={iconPortalterrenocom} />
}

export default IconPortalterrenocom
